<script>
import { Bar, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;
export default {
  extends: Bar,
  props: {
    chartData: {
      required: true,
    },
    options: {
      required: true,
    },
  },
  mixins: [reactiveProp],
  name: 'LineChart',
  mounted() {
    // Overwriting base render method with actual data.
    this.renderChart(this.chartData, this.options);
  },
};
</script>

<style scoped>

</style>
